<div class="p-lg-4 py-4 px-sm-4 px-2 min-vh-100 main-container d-flex align-items-center flex-column" [ngClass]="current_url.includes('/signup') || current_url.includes('/setup') ? 'justify-content-start' : 'justify-content-center'">
  <div class="create-account-container d-flex" [style.max-width.px]="current_url?.includes('verify-account') || (is_websignup && !is_signup_loading) ? '400': '1100'">
  <div class="d-flex flex-column" [ngClass]="is_websignup && params?.call_trial == '1' ? 'position-relative' : ''">
    <div class="d-flex brand-logo mt-2" [style.margin-bottom]="current_url.includes('/signup') || current_url.includes('/setup') ? '4rem' : '2rem'" [ngClass]="(current_url.includes('/signup') || current_url.includes('/setup') || current_url?.includes('verify-account')) && !is_websignup ? 'justify-content-start brand-logo-mobile' : 'justify-content-center'">
        <div class="d-flex align-items-center">
            <img src="assets/svg/truein-logo.svg">
        </div>
        <!-- <div *ngIf="current_url?.includes('signup')">
            <b> Already a user?</b>
            <button mat-button (click)="redirectToLogin();" type="button" class="ms-1 log-btn">Log in</button>
        </div>
        <div *ngIf="current_url?.includes('verify-account')">
            <button mat-button (click)="onLogOut();" type="button" class="ms-1 log-btn">Log Out</button>
        </div> -->
    </div>
    <div [style.visibility]="is_signup_loading && is_websignup ? 'hidden' : 'visible'" class="d-flex account-section-wrapper h-100 flex-sm-column-reverse flex-column-reverse flex-md-row">
      <div class="mt-5 mt-md-0 pb-4" *ngIf="!(current_url.includes('/login') || current_url.includes('/reset-password') || current_url?.includes('/verify-account') || is_websignup)">
        <div class="d-flex flex-column justify-content-between py-3" [ngClass]="current_url.includes('/signup') || current_url.includes('/setup') ? 'h-100' : ''">
          <div class="d-flex flex-column testimonial-wrapper">
            <span class="signup-title pb-5">
              See Truein in Action!
            </span>
            <div class="d-flex flex-column" (mouseenter)="stopTestimonialSlide()" (mouseleave)="showSlides()">
              <mat-tab-group class="testimonial-slider" [(selectedIndex)]="selectedSliderIndex">
                <ng-container *ngFor="let testimonial of testimonials">
                  <mat-tab disabled>
                    <div class="testimonial rounded-3 position-relative">
                      <div class="testimonial-feedback" [innerHTML]="testimonial.feedback"></div>
                      <!-- <div class="mt-1 d-flex position-absolute testimonial-name">
                          <b class="ms-auto">~{{testimonial.name}},
                              {{testimonial.company}}</b>
                      </div> -->
                      <div class="d-flex justify-content-between testimonial-profile-wrapper mt-4">
                        <div class="d-flex testimonial-testimonial-info">
                          <figure class="testimonial-profile-pic m-0">
                            <img [src]="testimonial.profile_pic" width="53" height="53" [alt]="testimonial.profile_pic">
                          </figure>
                          <div class="d-flex testimonial-profile-info flex-column justify-content-center align-items-start">
                            <h5 class="fw-bolder">{{testimonial.name}}</h5>
                            <span>{{testimonial.designation}}</span>
                            <!-- <span>{{testimonial.company}}</span> -->
                          </div>
                        </div>
                        <div class="d-flex">
                          <figure class="testimonial-profile-pic m-0">
                            <img [src]="testimonial.logo" [alt]="testimonial.company + 'logo'" width="85" height="60">
                          </figure>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                </ng-container>
              </mat-tab-group>
              <div class="testimonial-slider-nav mt-2 d-flex align-items-center justify-content-center">
                <ng-container *ngFor="let testimonial of testimonials; let index = index">
                  <button mat-icon-button aria-label="Slider button" [ngClass]="selectedSliderIndex == testimonial.index ? 'active' : ''" (click)="slideTestimonial(index)"></button>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <!-- <div class="pb-2">
                <div style="font-size:16px;" class="fw-bolder mb-3"> Why choose truein?</div>
                <div class="text-secondary" style="font-size:14px;">300+ Customers trust us across India,
                    GCC and APAC
                </div>
            </div> -->
            <div style="font-size:20px;" class="fw-bolder text-start"> Trusted by 500+ Customers globally</div>

            <div class="text-start px-2 pt-3">
              <div class="gallery d-grid">
                <figure class="d-flex justify-content-start m-0 my-3" *ngFor="let logo of client_logos;">
                  <img [src]="logo" width="80" height="55">
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column" [ngClass]="current_url.includes('/signup') || current_url.includes('/setup') ? 'sign-up-wrapper' : ''">
        <mat-card class="login-card h-100" [ngClass]="current_url.includes('/login') || current_url.includes('/reset-password') ? 'login-form' : current_url.includes('/setup') ? 'referral-component' : 'sign-up-form'" [attr.isWebSignUp]="is_websignup ? '1' : '0'">
          <div [ngClass]="current_url.includes('/signup') || current_url.includes('/setup') ? '' : 'row'" class="h-100">
            <div class="h-100 routing-container" [ngClass]="current_url.includes('/login') || current_url.includes('/reset-password') ? 'login-page px-lg-5 px-4' : current_url.includes('/setup') ? '' : 'px-lg-5 px-4'" [style.padding-bottom]="current_url.includes('/signup') ? '30px' : ''" [class.col-md-12]="current_url?.includes('verify-account')">
                <router-outlet></router-outlet>
            </div>
          </div>
        </mat-card>

        <div class="signup-privacy-line text-end text-center" [ngClass]="is_websignup ? 'm-0 mt-4' : ''" *ngIf="current_url.includes('/signup') || current_url.includes('/setup')">
          <span>By signing in, you acknowledge having read our <a target="_blank" href="https://truein.com/privacy-policy/">Privacy Notice</a> and <a target="_blank" href="https://truein.com/terms-conditions">Terms of Service.</a></span>
        </div>
      </div>
    </div>

    <div *ngIf="is_signup_loading && is_websignup" class="web-signup-loader text-center position-absolute d-flex flex-column align-items-center">
      <mat-spinner diameter="60"></mat-spinner>
      <span class="mt-3">
        Signing Up...
      </span>
    </div>
  </div>

  </div>
  <div class="privacy-line mt-3 text-center" *ngIf="current_url.includes('/login') || current_url.includes('/reset-password')">
    <span class="privacy-link">By logging in, you agree to our <a target="_blank" href="https://truein.com/privacy-policy">Privacy Policy</a> and <a target="_blank" href="https://truein.com/terms-conditions">Terms of Service.</a></span>
  </div>
  <div class="rights-text mt-2 text-center" *ngIf="current_url.includes('/login') || current_url.includes('/reset-password')">
    <span>Truein | All rights reserved © {{current_date.getFullYear()}}</span>
  </div>
</div>
